import React, { useContext } from 'react';
import profImg from '../../public/image/prof.png'
import adminImg from '../../public/image/admin.jpg'
import exitImg from '../../public/image/exit.png'
import ordersImg from '../../public/image/orders.jpg'
import Image from '../shared/Image';
import { useNavigate } from 'react-router-dom';
import { userLogout } from '../../service/userService';
import MainContext from '../../context/mainContext';
import { usePWAInstall } from 'react-use-pwa-install';
import logoImage from './../../public/image/logo400.png'

const Account = () => {

    const navigate = useNavigate();
    const context = useContext(MainContext)
    const install = usePWAInstall()

    return (
        <div className='categories-layer'>
            {
                (context.loggedIn && context.loggedIn.isAdmin) &&
                <div className='category-card'
                    onClick={() => navigate('/dashboard')}
                >
                    <div>
                        <Image
                            src={adminImg}
                            width={window.innerWidth < 576 ? 140 : 180}
                            height={window.innerWidth < 576 ? 105 : 135}
                        />
                        <div className='title'>
                            <div className=''>پنل مدیریت</div>
                        </div>
                    </div>
                </div>
            }
            <div className='category-card'
                onClick={() => navigate('/userInfo')}
            >
                <div>
                    <Image
                        src={profImg}
                        width={window.innerWidth < 576 ? 140 : 180}
                        height={window.innerWidth < 576 ? 105 : 135}
                    />
                    <div className='title'>
                        <div className=''>ویرایش اطلاعات</div>
                    </div>
                </div>
            </div>
            <div className='category-card'
                onClick={() => navigate('/userOrders')}
            >
                <div>
                    <Image
                        src={ordersImg}
                        width={window.innerWidth < 576 ? 140 : 180}
                        height={window.innerWidth < 576 ? 105 : 135}
                    />
                    <div className='title'>
                        <div className=''>سفارشات</div>
                    </div>
                </div>
            </div>
            {
                install &&
                <div className='category-card'
                    onClick={install}
                >
                    <div>
                        <Image
                            src={logoImage}
                            width={window.innerWidth < 576 ? 140 : 180}
                            height={window.innerWidth < 576 ? 105 : 135}
                        />
                        <div className='title'>
                            <div className=''>نصب برنامه</div>
                        </div>
                    </div>
                </div>
            }
            <div className='category-card'
                onClick={() => {
                    (async () => {
                        try {
                            await userLogout();
                            localStorage.removeItem('token');
                            context.logout();
                            navigate('/', { replace: true })
                        } catch (error) { }
                    })();
                }}
            >

                <div>
                    <Image
                        src={exitImg}
                        width={window.innerWidth < 576 ? 140 : 180}
                        height={window.innerWidth < 576 ? 105 : 135}
                    />
                    <div className='title'>
                        <div className=''>خروج از حساب کاربری</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Account;